import { render, staticRenderFns } from "./previewRecord.vue?vue&type=template&id=ec586f00&scoped=true&"
import script from "./previewRecord.vue?vue&type=script&lang=js&"
export * from "./previewRecord.vue?vue&type=script&lang=js&"
import style0 from "./previewRecord.vue?vue&type=style&index=0&id=ec586f00&lang=less&scoped=true&"
import style1 from "./previewRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec586f00",
  null
  
)

export default component.exports